import { deleteEmptyObj, formatCST } from '@/utils/utils'

const state = {
  page: 1,
  limit: 15,
  total: 0,
  class_id: '',
  mark_status: 0, // 1 :未发布 -99:删除 100:发布 -100:彻底删除'
  max_score: undefined,
  min_score: undefined,
  name: '',
  status: '',
  date: [],
  username: '',
  teachingRecordId: '',
  user_id: '',
  updated_at_from: null,
  updated_at_to: null,
  id: '',
  latest_work_url: '',
  praise_times: '',
  type: '',
  version: '', // kitten版本
  updated_at: '',
  switchTab: 0
}

const actions = {
  // 处理作品管理搜索条件
  handleSearchConditions({ commit, state }) {
    const data = {
      class_id: state.class_id,
      mark_status: state.mark_status,
      max_score: state.max_score * 20,
      min_score: state.min_score * 20,
      name: state.name,
      status: state.status,
      updated_at_from:
        state.updated_at_from && formatCST(state.updated_at_from),
      updated_at_to: state.updated_at_to && formatCST(state.updated_at_to),
      username: state.username,
      user_id: state.user_id,
      type: state.type === -1 ? 1 : state.type,
      version: state.type === -1 ? 4 : '',
      teachingRecordId: state.teachingRecordId
    }
    deleteEmptyObj(data)
    return data
  },
  // 获取作品管理数据
  async workManageGetData({ commit, state }) {
    const page = state.page
    const data = actions.handleSearchConditions({ commit, state })
    const res = await API.get(`/edu/zone/work/manager/works?page=${page}`, data)
    commit('setState', {
      module: 'workManage',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 获取教师作品
  async getTeacherWork({ commit, state }) {
    const page = state.page
    const data = {
      name: state.name,
      status: state.status,
      type: state.type === -1 ? 1 : state.type,
      version: state.type === -1 ? 4 : undefined,
      updated_at_from:
        state.updated_at_from && formatCST(state.updated_at_from),
      updated_at_to: state.updated_at_to && formatCST(state.updated_at_to),
      username: state.username
    }
    deleteEmptyObj(data)
    const res = await API.get(
      `/edu/zone/work/manager/self/works?page=${page}`,
      data
    )
    commit('setState', {
      module: 'workManage',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 老师查看学生scratch作品
  async getStudentScratch ({ commit, state }) {
    const page = state.page
    const data = {
      class_id: state.class_id,
      name: state.name,
      updated_at_from: state.updated_at_from && formatCST(state.updated_at_from),
      updated_at_to: state.updated_at_to && formatCST(state.updated_at_to),
      username: state.username
    }
    deleteEmptyObj(data)
    const res = await API.get(
      `/edu/zone/work/manager/scratch/works?page=${page}&limit=${state.limit}`,
      data
    )
    commit('setState', {
      module: 'workManage',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 保存评分
  async workManageScore({ commit }, playload) {
    const res = await API.patch('/edu/zone/work/manager/works/scores', playload)
    return res
  },
  // 导出
  async workManageExcel({ commit, state }) {
    const data = {
      class_id: state.class_id,
      mark_status: state.mark_status,
      max_score: state.max_score * 20,
      min_score: state.min_score * 20,
      name: state.name,
      status: state.status,
      updated_at_from:
        state.updated_at_from && formatCST(state.updated_at_from),
      updated_at_to:
        state.updated_at_to &&
        formatCST(moment(state.updated_at_to).add(24, 'h')),
      username: state.username,
      user_id: state.user_id,
      type: state.type,
      version: state.type === -1 ? 4 : undefined
    }
    deleteEmptyObj(data)
    const res = await API.get(`/edu/zone/work/manager/works/excel`, data, {
      responseType: 'arraybuffer',
      timeout: 0
    })
    return res
  },
  // 统计数据
  async workBarData({ commit }, playload) {
    const res = await API.get(
      `/edu/zone/work/manager/works/statistics`,
      playload
    )
    return res
  },
  // 根据角色查询班级
  async classSelect({ commit }) {
    const res = await API.get(`/edu/zone/work/manager/works/statistics/classes`)
    return res
  },
  // 教师查看学生作品互评信息
  async getWorkMutualInfo({ commit }, workId) {
    const res = await API.get(
      `/edu/zone/work/manager/works/${workId}/mutual/scores`
    )
    return res
  },
  // 删除作品
  async workManageDeleteWork({ commit }, data) {
    const res = await API.post(
      `/edu/zone/work/${data.id}/delete`
    )
    return res
  }
}

const mutations = {
  workManageInit(state) {
    state.page = 1
    state.class_id = ''
    state.mark_status = ''
    state.max_score = undefined
    state.min_score = undefined
    state.name = ''
    state.status = ''
    state.date = []
    state.updated_at_from = null
    state.updated_at_to = null
    state.username = ''
    state.id = ''
    state.latest_work_url = ''
    state.praise_times = ''
    state.type = ''
    state.version = undefined
    state.updated_at = ''
    state.user_id = ''
    state.teachingRecordId = ''
  },
  switchTab(state, tabIndex) {
    state.switchTab = tabIndex
  }
}

export default {
  state,
  actions,
  mutations
}
